module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.link) ? _c('a', {
    staticClass: "delivery-chips",
    attrs: {
      "target": "_blank",
      "href": _vm.link
    }
  }, [_c('ui-icon', {
    attrs: {
      "icon": "local_shipping"
    }
  }), _vm._v(_vm._s(_vm.$t('order.label.item.tracking.parcel-tracking')) + "\n")], 1) : _c('span', [_vm._v(_vm._s(_vm.$t('order.label.item.tracking.parcel-tracking-nolink')))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75921bd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeliveryChips.vue
// module id = 304
// module chunks = 2